// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option_2LP97VMjqO543E-gNWWS06","focused":"styles_focused_3jy-9asvMZnjhPKK9d43_H"};